module.exports = require("prismjs/components/prism-coffeescript.js");